import { useState } from "react";
import apiClient from "@/services/apiClient";

export const useStudentLogin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const login = async (email, password) => {
    setLoading(true);
    setError(null);

    try {
      const apiBaseUrl = (process.env.REACT_APP_API_URL).replace(/\/$/, "");
      const response = await apiClient.post(`${apiBaseUrl}/StudentLogin/login`, {
        email,
        password,
      });

      if (response.data?.success === true && response.data?.statusCode === 1) {
        return {
          success: true,
          message: response.data?.message || "Login successfully",
          data: response.data,
        };
      } else {
        const errorMsg = response.data?.message || "Login failed";
        setError(errorMsg);
        return {
          success: false,
          message: errorMsg,
          data: null,
        };
      }
    } catch (err) {
      console.error("Login failed", err);
      
      // Handle 401 Unauthorized response
      if (err.response?.status === 401) {
        const errorMsg = err.response?.data?.message || "Invalid email or password";
        setError(errorMsg);
        return {
          success: false,
          message: errorMsg,
          data: null,
        };
      }
      
      const errorMsg = err.response?.data?.message || "Unable to login. Please try again.";
      setError(errorMsg);
      return {
        success: false,
        message: errorMsg,
        data: null,
      };
    } finally {
      setLoading(false);
    }
  };

  return {
    login,
    loading,
    error,
  };
};
